<script>
    import { getIconURL } from './card_images.js';
    import { state, res, ui, prefs } from './stores.js';
    export let display = 0;
	export let p = false;
    export let name;

    export let opacity = 1;
    export let size = 20;
	export let hideIfEmpty = false;
    export let colour = 'white';
    export let boolean = false;

    let tokenComponent;

    $: if($ui.flash.some(f => f.p == p && f.r == name)){
		$ui.flash = $ui.flash.filter(f => f.p != p || f.r != name);
		flash(tokenComponent);
	}

	function flash(element) {
		requestAnimationFrame(() => {
			element.style.transition = 'none';
			element.style.color = 'yellow';
			element.style.backgroundColor = 'grey';

			setTimeout(() => {
				element.style.transition = 'color 1s, background 1s';
				element.style.color = '';
				element.style.backgroundColor = '';
			});
		});
	}

	function colourStyle(_){
		if($prefs.hasOwnProperty(`${display}Colour`)){
			let amount = $prefs[`${display}Colour`];
			return `filter: hue-rotate(${amount}deg);`
		}else{
			return ''
		}
	}

</script>
<div class="tokenrow" style='opacity: {opacity}; { ((display > 0) || !hideIfEmpty) ? '' : 'display: none;' }'>
    <div bind:this={tokenComponent} class="token" style="min-width: {size}vmin; min-height: {size}vmin;">
        <div class="imagediv"  style="background-image: url({getIconURL(name)}); {colourStyle($prefs)}">
        </div>
            <div class="tokencount" style="font-size: {size*.8}vmin; color: {colour}" >
                    {display}
            </div>
    </div>
</div>
<style>
	.change_button {
		touch-action: manipulation;
	}

	.edit {
		display: flex;
		flex-direction: column;
		background-color: black;
		color: white;
		border: 2px solid white;
	}

	.tokenrow {
		min-height: 0;
		min-width: 0;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		padding: 0.4vmin;
	}

    .token {
		/*display: grid;
		grid-template-columns: 1;
		justify-items: center;*/
		position: relative;
		text-align: center;

		height: 100%;
        pointer-events: all;
	}

    .tokencount {
		font-weight: bold;
		text-align: center;
		font-size: 9vmin;
		position: absolute;
		top: 50%;
		left: 50%;
		opacity: 90%;
		transform: translate(-50%, -50%);
		text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
		/*text-shadow: 0px 0px 10px black;*/
		display: flex;
		justify-content: center;
		align-items: center;
        pointer-events: all;
	}

    .imagediv {
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;
		position: absolute;
		opacity: 0.8;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		height: 100%;
		width: 100%;
        pointer-events: all;
	}

    button.incdec {
		background: black;
		border: 2px solid white;
		color: white;
		font-weight: bold;
		font-size: 9vmin;
		padding: 0;
		flex-grow: 1;
        pointer-events: all;
		touch-action: manipulation;
	}

	.editcomponent {
		font-weight: bold;
		text-align: center;
	}

	.editblock {
		display: flex;
		justify-content: center;
	}

	button {
		color: white;
		background-color: black;
		outline: none;
		font-weight: bold;
		font-size: 1.5vmin;
		margin: 0;
		min-width: 3vmin;
	}
</style>